import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import {
  Box,
  Card,
  CircularProgress,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import StyledTable from "../../../../shared/StyledTable/StyledTable";
import fetchWithAuth from "../../../../util/fetchWithAuth";
import { API_URL } from "../../../../util/url";
// ==== Стилизация аккордеона ====
const Accordion = styled((props) => (
  <MuiAccordion
    className="rmui-card"
    disableGutters
    elevation={0}
    square
    {...props}
  />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowForwardIosSharpIcon
        sx={{ fontSize: "0.9rem", color: "text.secondary" }}
      />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row",
  "& .MuiAccordionSummary-content": {
    marginRight: theme.spacing(1),
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    marginLeft: "auto",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: 0,
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const getSoldCount = (item) => Number(item?.sold_today ?? 0) || 0;

// ==== Функция для строки товара ====
const renderProductRow = (product, onClick, isCross) => (
  <TableRow
    key={isCross ? product.cross_id : product.id}
    onClick={() => onClick(isCross ? product.cross_id : product.id)}
    sx={{ cursor: "pointer" }}
  >
    <TableCell className="border-bottom" sx={{ padding: "12px 20px" }}>
      <Box display="flex" alignItems="center" gap={2}>
        <Box
          component="img"
          src={`${product.image}`}
          alt={product.title}
          sx={{
            width: 46,
            height: 46,
            objectFit: "cover",
            borderRadius: 1,
          }}
        />
        <Typography variant="subtitle2" fontWeight={500}>
          {product.title}
        </Typography>
      </Box>
    </TableCell>
    <TableCell className="border-bottom" sx={{ padding: "12px 20px" }}>
      {isCross ? product.cross_id : product.id}
    </TableCell>
    <TableCell className="border-bottom" sx={{ padding: "12px 20px" }}>
      {isCross ? product.quantity : product.sold_today ?? 0}
    </TableCell>
    <TableCell className="border-bottom" sx={{ padding: "12px 20px" }}>
      <Typography fontWeight={600}>
        {product.price && product.price !== "0.00" ? `${product.price} ₴` : "—"}
      </Typography>
    </TableCell>
  </TableRow>
);

// ==== Основной компонент ====
const TabContent = ({ tabIndex }) => {
  const isCrossTab = tabIndex !== 0;
  const [data, setData] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const handleChange = (panel) => (_, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleClick = (id) => {
    if (!isCrossTab) {
      navigate(`/management/scripts/${id}`);
    }
    if (isCrossTab) {
      navigate(`/management/cross-product/${id}`);
    }
  };

  useEffect(() => {
    const fetchCrmData = async () => {
      try {
        const res = await fetchWithAuth(API_URL + "/statistic/crm-products");
        if (!res.ok) throw new Error("Failed to load CRM products");
        const json = await res.json();
        setData(json);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCrmData();
  }, []);

  if (loading)
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );

  return (
    <Card className="rmui-card">
      {data.map((group, groupIndex) => {
        const panelId = `panel${groupIndex + 1}`;
        const items = Array.isArray(
          isCrossTab ? group.corss_products : group.products
        )
          ? isCrossTab
            ? group.corss_products
            : group.products
          : [];
        const sortedItems = [...items].sort(
          (a, b) => getSoldCount(b) - getSoldCount(a)
        );
        return (
          <Accordion
            key={panelId}
            expanded={expanded === panelId}
            onChange={handleChange(panelId)}
            sx={{ mb: 1 }}
            className="rmui-card"
          >
            <AccordionSummary
              aria-controls={`${panelId}-content`}
              id={`${panelId}-header`}
              sx={{ padding: "10px 25px" }}
            >
              <Typography
                variant="h6"
                fontWeight={600}
                fontSize="15px"
                flexGrow={1}
              >
                {group.name} — Баланс CRM: {group.crm_balance} ₴
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <StyledTable
                headers={["Назва товару", "ID", "Кількість", "Ціна"]}
                rows={sortedItems}
                renderRow={(row) =>
                  renderProductRow(row, handleClick, isCrossTab)
                }
              />
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Card>
  );
};

export default TabContent;
